import React from 'react';
import { Link } from 'react-router-dom';
import LuxuryThumb from "../assets/images/luxury-thumb.jpg";
import BoutiqueThumb from "../assets/images/boutique-thumb.jpg";
import EcoFriendlyThumb from "../assets/images/eco-friendly-thumb.webp";
import BudgetThumb from "../assets/images/budget-thumb.jpg";
import CasinoThumb from "../assets/images/casino-thumb.jpg";

import Header from '../LayoutComponents/Header';
import Footer from '../LayoutComponents/Footer';
const HotelReviews = () => {
  const hotelCategories = [
    {
      title: "Luxury Hotels",
      image: LuxuryThumb,
      url: "/luxury-hotel",
      heading: "Discover the Pinnacle of Elegance: Australia's Top Luxury Hotels",
      description: "Experience unparalleled opulence and comfort at Australia's finest luxury hotels. At cloudmingle, we review and recommend only the best of the best—hotels where sophistication meets exceptional service. Our curated list features hotels that offer exquisite accommodations, world-class amenities, and bespoke experiences. Whether you're looking for a lavish retreat in Toronto or a serene escape in the Rockies, explore our detailed reviews to find the ultimate luxury stay that suits your desires."
    },
    {
      title: "Boutique Hotels",
      image: BoutiqueThumb,
      url: "/boutique-hotel",
      heading: "Unique Charm and Personal Touch: Explore Australia's Best Boutique Hotels",
      description: "Immerse yourself in the distinctive allure of Australia's boutique hotels with cloudmingle. Our reviews highlight hotels that stand out for their unique character, personalized service, and creative design. From charming urban hideaways to quaint countryside escapes, these hotels offer a memorable and intimate experience tailored to individual tastes. Discover the boutique hotels that capture the essence of their locations and provide a truly special stay."
    },
    {
      title: "Eco-Friendly Hotels",
      image: EcoFriendlyThumb,
      url: "/eco-friendly-hotels",
      heading: "Sustainable Stays: Discover Australia's Leading Eco-Friendly Hotels",
      description: "At cloudmingle, we're dedicated to promoting eco-conscious travel with our selection of Australia's top eco-friendly hotels. These properties prioritize sustainability and offer green solutions without compromising on comfort and quality. Explore our reviews to find hotels that not only offer exceptional accommodations but also embrace practices that protect our planet. Enjoy a stay that's both luxurious and environmentally responsible."
    },
    {
      title: "Budget Hotels",
      image: BudgetThumb,
      url: "/budget-hotels",
      heading: "Affordable Comfort: Top Budget Hotels Across Australia",
      description: "Travel smart and save with cloudmingle's selection of the best budget hotels in Australia. We review accommodations that offer excellent value without sacrificing comfort and quality. From cost-effective city stays to affordable countryside retreats, find hotels that meet your needs while keeping your wallet happy. Discover the top budget options and enjoy a comfortable stay without breaking the bank."
    },
    {
      title: "Casino Hotels",
      image: CasinoThumb, // Note: This path might need correction
      url: "/casino-hotel",
      heading: "Thrilling Escapes: Explore Australia's Premier Casino Hotels",
      description: "For those seeking excitement and entertainment, cloudmingle presents a selection of Australia's top casino hotels. Our reviews highlight hotels that combine luxurious accommodations with the thrill of casino gaming. Whether you're drawn to the vibrant nightlife of Vancouver or the elegant gaming rooms of Montreal, find the perfect casino hotel that offers both indulgence and excitement. Get ready for an unforgettable stay with our expert recommendations."
    }
  ];

  return (
    <>
    <Header />
      <section className="section hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-10 mx-auto text-center">
              <h1 className="top-heading">Hotel <span>Reviews</span></h1>
            </div>
          </div>
        </div>
      </section>

      <section className="section hotel-review">
        <div className="container">
          {hotelCategories.map((category, index) => (
            <React.Fragment key={index}>
              <h3>{category.title}</h3>
              <div className="content">
                <img src={category.image} className="img-fluid float-img raduis-1r" alt={category.title} />
                <div>
                  <h3><Link to={category.url}>{category.heading}</Link></h3>
                  <p>{category.description}</p>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </section>
      
      <section className="legal-disclaimer">
        <div className="container">
          <p><strong>Legal Disclaimer:</strong> All casino services are strictly **offline** and comply with Norwegian gambling laws. Online gambling services are not offered. Please gamble responsibly.</p>
        </div>
      </section>
            <Footer />
      
    </>
  );
};

export default HotelReviews;